import { FaUsers } from "react-icons/fa";
import { BiCategoryAlt } from 'react-icons/bi'
import { BsShop } from 'react-icons/bs'
import { GiFruitBowl } from 'react-icons/gi'
import { MdHomeRepairService, MdCleaningServices, MdOutlineSpaceDashboard, } from 'react-icons/md'
import { HiOutlineDocumentDuplicate } from 'react-icons/hi'
import { AiOutlineShopping, AiOutlineGift, AiOutlinePushpin } from 'react-icons/ai'
import { FaShippingFast, FaSupple } from 'react-icons/fa'

import uuid from "react-uuid";
import { GiModernCity, GiMatterStates } from 'react-icons/gi'
import { FiUsers } from 'react-icons/fi'
import { GrUserAdmin } from 'react-icons/gr'
import { FaSnowman } from 'react-icons/fa'
import { RiAdminLine } from 'react-icons/ri'
import { FaWarehouse } from "react-icons/fa"
import { HiDatabase } from 'react-icons/hi';
import { IoPricetagsOutline } from 'react-icons/io5'
import { FaPeopleCarry } from 'react-icons/fa'
import { BiSupport } from 'react-icons/bi'
import { IoIosTime } from "react-icons/io";
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { MdOutlineDeliveryDining } from "react-icons/md";
import { SiTaxbuzz } from "react-icons/si";
import { MdOutlineDirectionsBike } from "react-icons/md";
import { IoIosNotifications } from "react-icons/io";

export const menuItems = [
    {
        id: uuid(),
        multiple: false,
        name: "Dashboard",
        menuLink: "/dashboard",
        active: "Dashboard",
        icon: MdOutlineSpaceDashboard,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Warehouse",
        menuLink: "/Warehouse?page=1",
        active: "Warehouse",
        icon: FaWarehouse,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Vendors",
        menuLink: "/Vendors?page=1&vendor-type=InActive",
        active: "Vendors",
        icon: FaUsers,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Users",
        menuLink: "/user?page=1",
        active: "Users",
        icon: FiUsers,
    },

    {
        id: uuid(),
        multiple: true,
        name: "Mobility Service",
        menuLink: "/Ca",
        active: "Mobility-service",
        items: [{ name: 'Users', menuLink: "/mobility-service/users?page=1", active: "Users_mobility", icon: GiFruitBowl }, { name: "Drivers", menuLink: '/mobility-services/drivers?page=1&tab=1', active: 'mobility_drivers', icon: MdHomeRepairService },
        { name: "Bookings", menuLink: '/mobility-services/bookings?page=1&tab=1', active: 'mobility_Bookings', icon: MdHomeRepairService },
        { name: "Banners", menuLink: '/mobility-services/banners', active: 'mobility_banners', icon: MdHomeRepairService },
        { name: "Withdraw Requests", menuLink: '/mobility-services/Withdraw_requests?tab=2&page=1', active: 'Withdraw_requests', icon: MdHomeRepairService },
        { name: "Transport Services", menuLink: '/mobility-services/Transport_services?tab=1&page=1', active: 'Transport_services', icon: MdHomeRepairService },
        { name: "Coupons", menuLink: '/mobility-services/coupons?page=1', active: 'Coupons-mobility', icon: MdHomeRepairService },
        { name: "Config", menuLink: '/mobility-services/config', active: 'config-mobility', icon: MdHomeRepairService },
        { name: "Cities", menuLink: '/mobility-services/cities?page=1', active: 'mobility_cities', icon: GiModernCity }


        ],
        icon: MdOutlineDeliveryDining,
    },

    {
        id: uuid(),
        multiple: true,
        name: "Category",
        menuLink: "/Ca",
        active: "Category",
        items: [{ name: 'Omnimart', menuLink: "/omnimart-categories?page=1", active: "Omnimart", icon: GiFruitBowl }, { name: "Services", menuLink: '/service-categories?page=1', active: 'Services', icon: MdHomeRepairService },],
        icon: BiCategoryAlt,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Subcategories",
        menuLink: "/subcategories?page=1",
        active: "Subcategories",
        icon: HiOutlineDocumentDuplicate,
    },
    {
        id: uuid(),
        multiple: true,
        name: "Services",
        menuLink: "/Ca",
        active: "Services",
        items: [{ name: 'All Services', menuLink: "/Services?page=1", active: "Service", icon: MdCleaningServices }, { name: 'Citywise', menuLink: "/Services/City?page=1", active: "Service-City", icon: MdCleaningServices }],
        icon: BiCategoryAlt,
    },
    // {
    //     id: uuid(),
    //     multiple: false,
    //     name: "Services",
    //     menuLink: "/Services?page=1",
    //     active: "Service",
    //     icon: MdCleaningServices,
    // },
    {
        id: uuid(),
        multiple: false,
        name: "Products",
        menuLink: "/Products?page=1",
        active: "Products",
        icon: AiOutlineShopping,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Warehouse Products",
        menuLink: "/warehouse-Products?page=1",
        active: "warehouseProducts",
        icon: HiDatabase,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Suppliers",
        menuLink: "/Suppliers?page=1",
        active: "Suppliers",
        icon: FaSupple,
    },
    {
        id: uuid(),
        multiple: true,
        name: "Banners",
        menuLink: "/Ca",
        active: "Banners",
        items: [{ name: 'Services', menuLink: "/service-banners?page=1", active: "ServiceBanners", icon: GiFruitBowl }, { name: 'Omnimart', menuLink: "/omnimart-banners?page=1", active: "Omnimart", icon: GiFruitBowl }],
        icon: BiCategoryAlt,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Coupons",
        menuLink: "/Coupons?page=1",
        active: "Coupons",
        icon: AiOutlineGift,
    },
    {
        id: uuid(),
        multiple: true,
        name: "Orders",
        menuLink: "/Ca",
        active: "Orders",
        items: [{ name: 'Service', menuLink: "/service-orders?page=1&tab=Active", active: "ServiceOrders", icon: FaShippingFast }, { name: 'Grocery', menuLink: "/grocery-orders?page=1&tab=Active", active: "GroceryOrders", icon: FaShippingFast }],
        icon: BiCategoryAlt,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Reports",
        menuLink: "/Reports?page=1",
        active: "Reports",
        icon: HiOutlineDocumentReport,
    },
    /*   {
          id: uuid(),
          multiple: false,
          name: "GST",
          menuLink: "/GST?page=1",
          active: "GST",
          icon: SiTaxbuzz,
      }, */
    {
        id: uuid(),
        multiple: false,
        name: "Shop",
        menuLink: "/shop?page=1",
        active: "Shop",
        icon: BsShop,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Purchase Orders",
        menuLink: "/purchaseorder?page=1",
        active: "purchaseOrders",
        icon: IoPricetagsOutline,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Societies",
        menuLink: "/societies?page=1",
        active: "Societies",
        icon: FaPeopleCarry,
    },
    {
        id: uuid(),
        multiple: false,
        name: "States",
        menuLink: "/States?page=1",
        active: "States",
        icon: GiMatterStates,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Cities",
        menuLink: "/Cities?page=1",
        active: "Cities",
        icon: GiModernCity,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Pincodes",
        menuLink: "/Pincodes?page=1",
        active: "Pincodes",
        icon: AiOutlinePushpin,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Delivery Types",
        menuLink: "/Delivery-types?page=1",
        active: "Delivery Types",
        icon: MdOutlineDeliveryDining,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Roles",
        menuLink: "/roles",
        active: "Roles",
        icon: GrUserAdmin,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Suggestions",
        menuLink: "/suggestions",
        active: "Suggestions",
        icon: FaSnowman,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Customer Support",
        menuLink: "/customer-support",
        active: "Customer Support",
        icon: BiSupport,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Guide Support",
        menuLink: "/guide-support",
        active: "Customer Support",
        icon: BiSupport,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Admin Users",
        menuLink: "/adminusers",
        active: "Admin Users",
        icon: RiAdminLine,
    },
    {
        id: uuid(),
        multiple: false,
        name: "Notifications",
        menuLink: "/notifications",
        active: "Notifications",
        icon: RiAdminLine,
    },

    {
        id: uuid(),
        multiple: false,
        name: "Slots",
        menuLink: "/slots",
        active: "Slots",
        icon: IoIosTime,
    },


];
